module.exports = __webpack_public_path__ + "img/cookies-illustration-sm-lp.e71ef68d.svg";